// extracted by mini-css-extract-plugin
module.exports = {"confirmModal":"_2tUuus","rentalDesc":"Txe_c0"};